import script from "./CarFilterSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./CarFilterSidebar.vue?vue&type=script&setup=true&lang=js"

import "./CarFilterSidebar.vue?vue&type=style&index=0&id=bc877d48&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc877d48"]])

export default __exports__